(function(window, document, $) {
	"use strict";
	var reportOrderHandler = {
		init: function() {
			this.$reportOrderForm = $('.reportOrderForm form');
			if(this.$reportOrderForm.length > 0){
				this.$reportOrderButton = $('.reportOrderButton');
				this.$submitMessage = this.$reportOrderForm.find('.reportOrderForm__submit__message');
				this.$submitButton = this.$reportOrderForm.find('.reportOrderForm__submit__button');
				this.$pul = $('[for="report_order_customer_pul"]');
				this.bindEvents();
			}
		},

		bindEvents: function() {
			this.$reportOrderButton.on('click', function(e) {
				e.preventDefault();
				$(this).toggleClass('reportOrderButton--open');
				$('.reportOrderForm').toggleClass('reportOrderForm--open');
			});

			$('.reportOrderForm__submit__message__exit').on('click', function() {
				this.$submitMessage.hide();
			}.bind(this));

			this.$pul.on('keydown', function(e) {
				var code = (e.keyCode ? e.keyCode : e.which);
				if (code == 13) {
					$(this).trigger('click');
				}
			})

			this.$reportOrderForm.on('submit', function(e) {
				e.preventDefault();
				this.$submitButton.prop('disabled', true);
				this.$submitButton.addClass('reportOrderForm__submit__button--fetching');
				var formData = this.$reportOrderForm.serializeArray();
				$.post(this.$reportOrderForm.attr('action'), formData, function(data) {
					if (data.hasOwnProperty('status') && data.status == 'ok') {
						this.$submitMessage.addClass('status-ok');
					} else {
						this.$submitMessage.removeClass('status-ok');
					}

					this.$reportOrderForm.get(0).reset();
					this.$submitButton.prop('disabled', false);
					this.$submitButton.removeClass('reportOrderForm__submit__button--fetching');
					this.$submitMessage.show();

				}.bind(this));
			}.bind(this));
		}
	};
	$(document).ready( function(){
		reportOrderHandler.init();
	});
})(window, document, jQuery);

